// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/6/6
// +-------------------------------------------------------------
// |Time: 12:11
// +-------------------------------------------------------------
export default [
    {
        path: '/user/coupon-list',
        name: 'CouponRecordList',
        component: () => import('@/views/User/CouponRecord/Index.vue'),
        meta: {title: '我的优惠券'},
    },
    {
        path: '/user/real-auth',
        name: 'RealAuth',
        component: () => import('@/views/User/Center/RealAuth.vue'),
        meta: {title: '实名认证'},
    },
]